import { ConfigurationRepositoryConfigurationCommandsService } from '@festina/configuration-general-types/configuration/services/ConfigurationRepositoryConfigurationCommandsService'
import type { ConfigurableServer } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

type InputArguments = {
  branchName: string
  baseBranchName: string
  server: ConfigurableServer
}

export const usePushBranchToBaseBranch = () =>
  useMutation({
    mutationFn: async ({ branchName, server }: InputArguments) => {
      await ConfigurationRepositoryConfigurationCommandsService.configurationCommandServicePostPushBranch(
        {
          requestBody: {
            _type: 'BranchCommandSpecification',
            branchName,
            componentName: server.toLocaleLowerCase(),
          },
        },
      )
    },
  })
